import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  RETRIEVE_MANY_STORAGE_FACILITIES: `${SLICE_NAME}/retrieve_many_storage_facilities`,
} as const;
